import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'

  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useShopifyClient from '@/composables/useShopifyClient'
  import useSegment from '@/composables/useSegment'

  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BuyPackageDetails',
  setup(__props) {

  const { mediaIcon, arrowRightIndicator } = useIcons()
  const { courseBundle } = useCourse()
  const { handleShopifyCheckout } = useShopifyClient()
  const { coursePackagePurchaseIntended } = useSegment()

  const isLoading = ref(false)

  const totalCoursePrice = computed(() => {
    return courseBundle.value?.courses?.reduce((total, course) => total + (course.shopifyProductPrice || 0), 0)
  })

  const buyNow = () => {
    coursePackagePurchaseIntended(courseBundle.value!.courseBundleId, courseBundle.value!.title, 'bundle_upsell')
    isLoading.value = true

    handleShopifyCheckout(courseBundle.value!.shopifyProductVariantId!, UserModule.email || null)

    setTimeout(() => {
      isLoading.value = false
    }, 1000)
  }

return { __sfc: true,mediaIcon, arrowRightIndicator, courseBundle, handleShopifyCheckout, coursePackagePurchaseIntended, isLoading, totalCoursePrice, buyNow, computed, ref, SVGRenderer, KetchUpButton, LoadingSpinner, HTMLRenderer, useIcons, useCourse, useShopifyClient, useSegment, UserModule }
}

})